module.exports = __webpack_public_path__ + "static/media/work-img11.d6bacc19.jpg";